import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<footer class=\"text-center py-4 rext-secondary bg-light mt-6\"><small><ul class=\"list-inline mb-0\"><li class=\"list-inline-item\">© 2020 知乎专栏</li><li class=\"list-inline-item\">课程</li><li class=\"list-inline-item\">文档</li><li class=\"list-inline-item\">联系</li><li class=\"list-inline-item\">更多</li></ul></small></footer>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_global_header = _resolveComponent("global-header")!
  const _component_Loader = _resolveComponent("Loader")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_global_header, { user: _ctx.currentUser }, null, 8, ["user"]),
    (_ctx.isLoading)
      ? (_openBlock(), _createBlock(_component_Loader, {
          key: 0,
          text: '努力加载中...'
        }, null, 8, ["text"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_router_view)
    ]),
    _hoisted_2
  ], 64))
}